import React from 'react';
import { RedirectToSignIn } from '@clerk/clerk-react';

const LoginPage = () => {
  return (
    <RedirectToSignIn 
      redirectUrl="/"
    />
  );
};

export default LoginPage;
